import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const googleCalendarRoot = (state: State) => state.googleCalendar;

export const userSettingSelector = createSelector(
  googleCalendarRoot,
  (googleCalendar) => googleCalendar.userSettings
);
